import React from 'react';
import ClubCard from './ClubCard';
import StartClubCard from './StartClubCard';
import { cardHeight, columnize, START_CARD_H } from './clubMasonry';

/**
 * The club grid (clubs redesign handoff §3): independent columns, each card into whichever is
 * shortest at the time it's placed, ties to the left.
 *
 * Not CSS `column-count` — that fills top to bottom and leaves the stragglers in the bottom
 * right, which on a nine-club list reads as a broken page rather than a grid.
 */
export default function ClubGrid({
  clubs,
  cols,
  gap,
  ratios = {},
  onRatio,
  onOpen,
  onJoin,
  busyId = null,
  hoverable = true,
  showStart = false,
  onStart,
}) {
  const items = [];
  if (showStart) items.push({ key: '__start__', h: START_CARD_H, start: true });
  clubs.forEach((club) => {
    items.push({ key: club.id, h: cardHeight(club.coverUrl ? ratios[club.coverUrl] : 0), club });
  });

  const columns = columnize(items, cols);

  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols},minmax(0,1fr))`, gap, alignItems: 'start' }} data-testid="club-columns" data-cols={cols}>
      {columns.map((column, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} style={{ display: 'flex', flexDirection: 'column', gap, minWidth: 0 }}>
          {column.map((item) => (item.start ? (
            <StartClubCard key={item.key} onStart={onStart} />
          ) : (
            <ClubCard
              key={item.key}
              club={item.club}
              ratio={item.club.coverUrl ? ratios[item.club.coverUrl] : undefined}
              onRatio={onRatio}
              onOpen={() => onOpen(item.club)}
              onJoin={(kind) => onJoin(item.club, kind)}
              busy={busyId === item.club.id}
              hoverable={hoverable}
            />
          )))}
        </div>
      ))}
    </div>
  );
}
